export const Method = {
  Email: 'Email',
  Sms: 'SMS'
};
